export default {
  getTableSettings: (state) => state.tableSettings,
  getNotifications: (state) => state.notifications,
  getIsTableLoading: (state) => state.isTableLoading,
}
